export function getElementConfig() {
    const rootelement = document.getElementById("glasses-main-app");
    const attributenames = rootelement.getAttributeNames();
    let attributes = {}
    attributenames.forEach(function (el) {
        if (el.indexOf('data-cfg-') === 0) {
            attributes[el.substr(9)] = rootelement.getAttribute(el)
        }
    })

    let config = {}
    for (var prop in attributes) {
        config[camelized(prop)] = toInteger(toBoolean(toObject(attributes[prop])))
    }
    function toObject(str) {
        return str.replace(/'/g, '"')
    }
    function toBoolean(str) {
        var ret  =  str.toLowerCase() === "false" ? false : str
        return str.toLowerCase() === "true" ? true : ret
    }
    function toInteger(str) {
        return isNaN(parseInt(str)) ? str : parseInt(str)
    }
    function camelized(str) {
        return str.replace(/\W+(.)/g, function (match, chr) {
            return chr.toUpperCase();
        });
    }

    return config
}